"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var query_string_1 = require("query-string");
var ra_core_1 = require("ra-core");
exports.default = (function (apiUrl, httpClient) {
    if (httpClient === void 0) { httpClient = ra_core_1.fetchUtils.fetchJson; }
    return ({
        getList: function (resource, params) {
            var _a = params.pagination, page = _a.page, perPage = _a.perPage;
            var _b = params.sort, field = _b.field, order = _b.order;
            var query = __assign(__assign({}, params.filter), { page: page, per_page: perPage, sort_by: field, sort_order: order });
            var url = "".concat(apiUrl, "/").concat(resource, "?").concat((0, query_string_1.stringify)(query));
            var options = {};
            return httpClient(url, options).then(function (_a) {
                var _b;
                var json = _a.json;
                return {
                    data: json.data,
                    total: (_b = json.meta) === null || _b === void 0 ? void 0 : _b.total,
                    meta: json.meta,
                };
            });
        },
        getOne: function (resource, params) {
            return httpClient("".concat(apiUrl, "/").concat(resource, "/").concat(params.id)).then(function (_a) {
                var json = _a.json;
                return ({
                    data: json.data,
                });
            });
        },
        getMany: function (resource, params) {
            var query = {
                ids: params.ids.join(","),
            };
            var url = "".concat(apiUrl, "/").concat(resource, "?").concat((0, query_string_1.stringify)(query));
            return httpClient(url).then(function (_a) {
                var json = _a.json;
                return ({ data: json, meta: json.meta });
            });
        },
        getManyReference: function (resource, params) {
            var _a;
            var _b = params.pagination, page = _b.page, perPage = _b.perPage;
            var _c = params.sort, field = _c.field, order = _c.order;
            var query = __assign(__assign({}, params.filter), (_a = { page: page, per_page: perPage, sort_by: field, sort_order: order }, _a[params.target] = params.id, _a));
            var url = "".concat(apiUrl, "/").concat(resource, "?").concat((0, query_string_1.stringify)(query));
            return httpClient(url).then(function (_a) {
                var json = _a.json;
                return ({ data: json, meta: json.meta });
            });
        },
        update: function (resource, params) {
            var _a;
            var csrfToken = ((_a = document.querySelector("meta[name=\"csrf-token\"]")) === null || _a === void 0 ? void 0 : _a.getAttribute("content")) || "";
            return httpClient("".concat(apiUrl, "/").concat(resource, "/").concat(params.id), {
                method: "PUT",
                headers: new Headers({
                    "Content-Type": "application/json",
                    "X-CSRF-TOKEN": csrfToken,
                }),
                body: JSON.stringify(params.data),
            }).then(function (_a) {
                var json = _a.json;
                return ({ data: json });
            });
        },
        updateMany: function (resource, params) {
            var _a;
            var csrfToken = ((_a = document.querySelector("meta[name=\"csrf-token\"]")) === null || _a === void 0 ? void 0 : _a.getAttribute("content")) || "";
            return Promise.all(params.ids.map(function (id) {
                return httpClient("".concat(apiUrl, "/").concat(resource, "/").concat(id), {
                    method: "PUT",
                    headers: new Headers({
                        "Content-Type": "application/json",
                        "X-CSRF-TOKEN": csrfToken,
                    }),
                    body: JSON.stringify(params.data),
                });
            })).then(function (responses) { return ({ data: responses.map(function (_a) {
                    var json = _a.json;
                    return json.id;
                }) }); });
        },
        create: function (resource, params) {
            var _a;
            var csrfToken = ((_a = document.querySelector("meta[name=\"csrf-token\"]")) === null || _a === void 0 ? void 0 : _a.getAttribute("content")) || "";
            return httpClient("".concat(apiUrl, "/").concat(resource), {
                method: "POST",
                headers: new Headers({
                    "Content-Type": "application/json",
                    "X-CSRF-TOKEN": csrfToken,
                }),
                body: JSON.stringify(params.data),
            }).then(function (_a) {
                var json = _a.json;
                return ({ data: json });
            });
        },
        delete: function (resource, params) {
            var _a;
            var csrfToken = ((_a = document.querySelector("meta[name=\"csrf-token\"]")) === null || _a === void 0 ? void 0 : _a.getAttribute("content")) || "";
            return httpClient("".concat(apiUrl, "/").concat(resource, "/").concat(params.id), {
                method: "DELETE",
                headers: new Headers({
                    "X-CSRF-TOKEN": csrfToken,
                }),
            }).then(function (_a) {
                var json = _a.json;
                return ({ data: json });
            });
        },
        deleteMany: function (resource, params) {
            var _a;
            var csrfToken = ((_a = document.querySelector("meta[name=\"csrf-token\"]")) === null || _a === void 0 ? void 0 : _a.getAttribute("content")) || "";
            return Promise.all(params.ids.map(function (id) {
                return httpClient("".concat(apiUrl, "/").concat(resource, "/").concat(id), {
                    method: "DELETE",
                    headers: new Headers({
                        "X-CSRF-TOKEN": csrfToken,
                    }),
                });
            })).then(function (responses) { return ({
                data: responses.map(function (_a) {
                    var json = _a.json;
                    return json.id;
                }),
            }); });
        },
        getLatestVersions: function (endpoint) {
            var url = "".concat(apiUrl, "/").concat(endpoint);
            return httpClient(url).then(function (_a) {
                var json = _a.json;
                return json.data;
            });
        },
        updateAppVersion: function (appId, version, patchVersion) {
            var _a;
            var url = "/api/apps/".concat(appId, "/version");
            var csrfToken = ((_a = document.querySelector("meta[name=\"csrf-token\"]")) === null || _a === void 0 ? void 0 : _a.getAttribute("content")) || "";
            return httpClient(url, {
                method: "PUT",
                body: JSON.stringify({ version: version, patch_version: patchVersion }),
                headers: new Headers({
                    "Content-Type": "application/json",
                    "X-CSRF-TOKEN": csrfToken,
                }),
            }).then(function (_a) {
                var json = _a.json;
                return json;
            });
        },
        updateAppTemplateVersion: function (appId, version, patchVersion) {
            var _a;
            var url = "/api/app-template-editor/".concat(appId, "/version");
            var csrfToken = ((_a = document.querySelector("meta[name=\"csrf-token\"]")) === null || _a === void 0 ? void 0 : _a.getAttribute("content")) || "";
            return httpClient(url, {
                method: "PUT",
                body: JSON.stringify({ version: version, patch_version: patchVersion }),
                headers: new Headers({
                    "Content-Type": "application/json",
                    "X-CSRF-TOKEN": csrfToken,
                }),
            }).then(function (_a) {
                var json = _a.json;
                return json;
            });
        },
        deleteSetting: function (appId, version, key) {
            var _a;
            var csrfToken = ((_a = document.querySelector("meta[name=\"csrf-token\"]")) === null || _a === void 0 ? void 0 : _a.getAttribute("content")) || "";
            var url = "/api/app-editor/app-versions/".concat(appId, "/").concat(version, "/settings");
            return httpClient(url, {
                method: "DELETE",
                body: JSON.stringify({ key: key }),
                headers: new Headers({
                    "Content-Type": "application/json",
                    "X-CSRF-TOKEN": csrfToken,
                }),
            }).then(function (_a) {
                var json = _a.json;
                return json;
            });
        },
        deleteTemplateSetting: function (appTemplateId, version, key) {
            var _a;
            var csrfToken = ((_a = document.querySelector("meta[name=\"csrf-token\"]")) === null || _a === void 0 ? void 0 : _a.getAttribute("content")) || "";
            var url = "/api/app-template-editor/app-template-versions/".concat(appTemplateId, "/").concat(version, "/settings");
            return httpClient(url, {
                method: "DELETE",
                body: JSON.stringify({ key: key }),
                headers: new Headers({
                    "Content-Type": "application/json",
                    "X-CSRF-TOKEN": csrfToken,
                }),
            }).then(function (_a) {
                var json = _a.json;
                return json;
            });
        },
        get: function (resource) {
            var url = "".concat(apiUrl, "/").concat(resource);
            return httpClient(url).then(function (_a) {
                var json = _a.json;
                return {
                    data: json.data || json,
                };
            });
        },
        deleteResource: function (integrationId, key) {
            var _a;
            var csrfToken = ((_a = document.querySelector("meta[name=\"csrf-token\"]")) === null || _a === void 0 ? void 0 : _a.getAttribute("content")) || "";
            var url = "".concat(apiUrl, "/app-integrations/delete/resource/").concat(integrationId);
            return httpClient(url, {
                method: "DELETE",
                headers: new Headers({
                    "X-CSRF-TOKEN": csrfToken,
                    "Content-Type": "application/json",
                }),
                body: JSON.stringify({ key: key }),
            }).then(function (_a) {
                var json = _a.json;
                return ({ data: json });
            });
        },
        createTemplateResource: function (appTemplateId, version, key, resource, options) {
            var _a;
            var csrfToken = ((_a = document.querySelector("meta[name=\"csrf-token\"]")) === null || _a === void 0 ? void 0 : _a.getAttribute("content")) || "";
            var url = "/api/app-template-editor/app-template-versions/".concat(appTemplateId, "/").concat(version, "/resources");
            return httpClient(url, {
                method: "POST",
                body: JSON.stringify({
                    key: key,
                    resource: resource,
                    isUpdate: (options === null || options === void 0 ? void 0 : options.isUpdate) || false,
                    originalKey: options === null || options === void 0 ? void 0 : options.originalKey
                }),
                headers: new Headers({
                    "Content-Type": "application/json",
                    "X-CSRF-TOKEN": csrfToken,
                }),
            }).then(function (_a) {
                var json = _a.json;
                return json;
            });
        },
        updateTemplateResources: function (appTemplateId, version, resources) {
            var _a;
            var csrfToken = ((_a = document.querySelector("meta[name=\"csrf-token\"]")) === null || _a === void 0 ? void 0 : _a.getAttribute("content")) || "";
            var url = "/api/app-template-editor/app-template-versions/".concat(appTemplateId, "/").concat(version, "/resources");
            return httpClient(url, {
                method: "PUT",
                body: JSON.stringify({ resources: resources }),
                headers: new Headers({
                    "Content-Type": "application/json",
                    "X-CSRF-TOKEN": csrfToken,
                }),
            }).then(function (_a) {
                var json = _a.json;
                return json;
            });
        },
        deleteTemplateResource: function (appTemplateId, version, key) {
            var _a;
            var csrfToken = ((_a = document.querySelector("meta[name=\"csrf-token\"]")) === null || _a === void 0 ? void 0 : _a.getAttribute("content")) || "";
            var url = "/api/app-template-editor/app-template-versions/".concat(appTemplateId, "/").concat(version, "/resources");
            return httpClient(url, {
                method: "DELETE",
                body: JSON.stringify({ key: key }),
                headers: new Headers({
                    "Content-Type": "application/json",
                    "X-CSRF-TOKEN": csrfToken,
                }),
            }).then(function (_a) {
                var json = _a.json;
                return json;
            });
        },
        updateIntegrationTemplate: function (templateId, data) {
            var _a;
            var csrfToken = ((_a = document.querySelector("meta[name=\"csrf-token\"]")) === null || _a === void 0 ? void 0 : _a.getAttribute("content")) || "";
            var url = "".concat(apiUrl, "/integration-templates/update/").concat(templateId);
            return httpClient(url, {
                method: "PUT",
                body: JSON.stringify(data),
                headers: new Headers({
                    "Content-Type": "application/json",
                    "X-CSRF-TOKEN": csrfToken,
                }),
            }).then(function (_a) {
                var json = _a.json;
                return json;
            });
        },
        updateAppAccess: function (appId, updates) {
            var _a;
            var csrfToken = ((_a = document.querySelector("meta[name=\"csrf-token\"]")) === null || _a === void 0 ? void 0 : _a.getAttribute("content")) || "";
            var url = "".concat(apiUrl, "/apps/").concat(appId, "/access");
            return httpClient(url, {
                method: "POST",
                headers: new Headers({
                    "Content-Type": "application/json",
                    "X-CSRF-TOKEN": csrfToken,
                }),
                body: JSON.stringify({
                    updates: updates
                }),
            }).then(function (_a) {
                var json = _a.json;
                return json;
            });
        },
        getAppAccess: function (appId) {
            var url = "".concat(apiUrl, "/apps/").concat(appId, "/access");
            return httpClient(url, {
                method: "GET",
                headers: new Headers({
                    "Content-Type": "application/json",
                }),
            }).then(function (_a) {
                var json = _a.json;
                return json;
            });
        },
        getAppTemplateAccess: function (templateId) {
            var url = "".concat(apiUrl, "/app-templates/").concat(templateId, "/access");
            return httpClient(url, {
                method: "GET",
                headers: new Headers({
                    "Content-Type": "application/json",
                }),
            }).then(function (_a) {
                var json = _a.json;
                return json;
            });
        },
        updateAppTemplateAccess: function (templateId, updates) {
            var _a;
            var csrfToken = ((_a = document.querySelector("meta[name=\"csrf-token\"]")) === null || _a === void 0 ? void 0 : _a.getAttribute("content")) || "";
            var url = "".concat(apiUrl, "/app-templates/").concat(templateId, "/access");
            return httpClient(url, {
                method: "POST",
                headers: new Headers({
                    "Content-Type": "application/json",
                    "X-CSRF-TOKEN": csrfToken,
                }),
                body: JSON.stringify({
                    updates: updates
                }),
            }).then(function (_a) {
                var json = _a.json;
                return json;
            });
        },
        getIntegrationTemplateAccess: function (templateId) {
            var url = "".concat(apiUrl, "/integration-templates/").concat(templateId, "/access");
            return httpClient(url, {
                method: "GET",
                headers: new Headers({
                    "Content-Type": "application/json",
                }),
            }).then(function (_a) {
                var json = _a.json;
                return json;
            });
        },
        updateIntegrationTemplateAccess: function (templateId, updates) {
            var _a;
            var csrfToken = ((_a = document.querySelector("meta[name=\"csrf-token\"]")) === null || _a === void 0 ? void 0 : _a.getAttribute("content")) || "";
            var url = "".concat(apiUrl, "/integration-templates/").concat(templateId, "/access");
            return httpClient(url, {
                method: "POST",
                headers: new Headers({
                    "Content-Type": "application/json",
                    "X-CSRF-TOKEN": csrfToken,
                }),
                body: JSON.stringify({
                    updates: updates
                }),
            }).then(function (_a) {
                var json = _a.json;
                return json;
            });
        },
    });
});
